<main class="page-main">
  <div class="layout layout--central">
    <div class="layout__row">

      <div class="layout__sidecol">
        <nav class="central-mainnav" id="app-bar-desktop">
            <ul class="central-mainnav__list list-unstyled">
                <!-- <li [routerLinkActive]="'is-active'" [routerLinkActiveOptions]="{exact: true}">
                    <a *ngIf="person?.broker_id > 0 || person?.console_access"  href="javascript:void(0);" routerLink="/broker-dashboard">
                        <svg class="icon">
                            <use xlink:href="#dashboard-filled"></use>
                        </svg>
                        <span>Home</span>
                    </a>
                </li> -->
                <li [class]="mode === 'Policies' ? 'is-active' : '' " >
                    <a href="javascript:void(0);" (click)="changeMode('Policies')">
                        <svg class="icon">
                            <use xlink:href="#policies-filled"></use>
                        </svg>
                        <span>Policies</span>
                    </a>
                </li>
                <li *ngIf="person?.broker_id > 0 || person?.console_access" [class]="mode === 'Quotes' ? 'is-active' : '' ">
                    <a href="javascript:void(0);" (click)="changeMode('Quotes')">
                        <svg class="icon">
                            <use xlink:href="#quotes-filled"></use>
                        </svg>
                        <span>Quotes</span>
                    </a>
                </li>
                <li *ngIf="claims" [class]="mode === 'Claims' ? 'is-active' : '' ">
                    <a href="javascript:void(0);"  (click)="changeMode('Claims')">
                        <svg class="icon">
                            <use xlink:href="#claims-filled"></use>
                        </svg>
                        <span>Claims</span>
                    </a>
                </li>
                <!-- <li *ngIf="underwriting" [class]="mode === 'Underwriting' ? 'is-active' : '' ">
                  <a href="javascript:void(0);"  (click)="changeMode('Underwriting')">
                      <svg class="icon">
                          <use xlink:href="#claims-filled"></use>
                      </svg>
                      <span>Underwriting</span>
                  </a>
              </li> -->
                <li [ngClass]="moreActiveDesktop ? 'is-active':null">
                    <a href="javascript:;" (click)="activateMore('desktop')" id="sidesheet-appbar-more-trigger">
                        <svg class="icon">
                            <use xlink:href="#more-circle-filled"></use>
                        </svg>
                        <span>More</span>
                    </a>
                </li>
            </ul>
        </nav>
        <!-- <div class="central-getassistance">
            <a href="javascript:;" (click)="startSOSFlow()"  class="central-getassistance__btn"><svg class="icon">
                    <use xlink:href="#navigation-sos"></use>
                </svg></a>
        </div> -->
      </div>
      <nav class="app-bar" [ngClass]="moreActiveMobile ? 'more-active':null" id="app-bar">
        <ul>
           <!-- <li [routerLinkActive]="'is-active'"  [routerLinkActiveOptions]="{exact: true}">
              <a href="javascript:void(0);" *ngIf="person?.broker_id > 0 || person?.console_access"  href="javascript:void(0);" routerLink="/broker-dashboard">
                 <svg class="icon">
                    <use xlink:href="#dashboard-filled"></use>
                 </svg>
                 <span>Home</span>
              </a>
           </li> -->
           <li [class]="mode === 'Policies' ? 'is-active' : '' " >
              <a href="javascript:void(0);" (click)="changeMode('Policies')">
                 <svg class="icon">
                    <use xlink:href="#policies-filled"></use>
                 </svg>
                 <span>Policies</span>
              </a>
           </li>
           <li *ngIf="person?.broker_id > 0 || person?.console_access" [class]="mode === 'Quotes' ? 'is-active' : '' ">
              <a href="javascript:void(0);" (click)="changeMode('Quotes')">
                 <svg class="icon">
                    <use xlink:href="#quotes-filled"></use>
                 </svg>
                 <span>Quotes</span>
              </a>
           </li>
           <li *ngIf="claims" [class]="mode === 'Claims' ? 'is-active' : '' ">
              <a href="javascript:void(0);" (click)="changeMode('Claims')">
                 <svg class="icon">
                    <use xlink:href="#claims-filled"></use>
                 </svg>
                 <span>Claims</span>
              </a>
           </li>
           <li [ngClass]="moreActiveMobile ? 'is-active':null">
              <a href="#app-bar-more" (click)="activateMore('mobile')" data-toggle="modal">
                 <svg class="icon">
                    <use xlink:href="#more-circle-filled"></use>
                 </svg>
                 <span>More</span>
              </a>
           </li>
        </ul>
      </nav>
      <div class="sidesheet-appbar" [ngClass]="moreActiveDesktop ? 'is-active':null" id="sidesheet-appbar-more">
        <div class="sidesheet-appbar__inner">
          
          <div class="sidesheet-appbar__body">
      
           <nav class="modal-appbar__menu">
           
               <div class="modal-appbar__menu-title"><small>Cover</small></div>
               <ul>
                  <li *ngIf="underwriting" [ngClass]="underwriting ? 'is-active': null" >
                     <a href="javascript:;" (click)="changeMode('Underwriting')">
                        <svg class="icon"><use xlink:href="#flag"></use></svg>
                        <span>Underwriting</span>
                     </a>
                  </li>
               </ul>
           
               <!-- <div class="modal-appbar__menu-title"><small>Policies</small></div>
               <ul>
                  <li>
                     <a href="javascript:;" [routerLink]="['/' + RouterLinks.PolicyResources]">
                        <svg class="icon"><use xlink:href="#document"></use></svg>
                        <span>Documents</span>
                     </a>
                  </li>
                  <li>
                     <a href="javascript:;" [routerLink]="['/' + RouterLinks.PolicyInsuredItems]">
                        <svg class="icon"><use xlink:href="#inventory"></use></svg>
                        <span>Insured items</span>
                     </a>
                  </li>
                  <li>
                     <a href="javascript:;" [routerLink]="['/' + RouterLinks.PolicyAddons]">
                        <svg class="icon"><use xlink:href="#policy-benefits"></use></svg>
                        <span>Benefits</span>
                     </a>
                  </li>
                  <li>
                    <a href="javascript:;" [routerLink]="['/' + RouterLinks.Account]">
                       <svg class="icon"><use xlink:href="#profile"></use></svg>
                       <span>Profile</span>
                    </a>
                 </li>
               </ul> -->
           
               <!-- <div class="modal-appbar__menu-title"><small>Support</small></div>
               <ul>
                  <li>
                     <a href="#">
                        <svg class="icon"><use xlink:href="#mobile-call"></use></svg>
                        <span>Give us a call</span>
                     </a>
                  </li>
                  <li>
                     <a href="#">
                        <svg class="icon"><use xlink:href="#request-call"></use></svg>
                        <span>Request a call</span>
                     </a>
                  </li>
                  <li>
                     <a href="#">
                        <svg class="icon"><use xlink:href="#chat"></use></svg>
                        <span>Chat to us</span>
                     </a>
                  </li>
               </ul> -->

               <div class="modal-appbar__menu-title"><small>General</small></div>
               <ul>
                  <li [class]="mode === 'Notifications' ? 'is-active' : ''">
                     <a href="javascript:;" (click)="changeMode('Notifications')">
                        <svg class="icon"><use xlink:href="#notifications"></use></svg>
                        <span>Notifications</span>
                     </a>
                  </li>
               </ul>

               <div class="modal-appbar__menu-title"><small>Resources</small></div>
               <ul>
                  <li>
                     <a href="#">
                        <svg class="icon"><use xlink:href="#video-screen"></use></svg>
                        <span>Tips and how-tos</span>
                     </a>
                  </li>
                  <li>
                     <a href="#">
                        <svg class="icon"><use xlink:href="#q-a"></use></svg>
                        <span>FAQs</span>
                     </a>
                  </li>
                  <li>
                     <a href="#">
                        <svg class="icon"><use xlink:href="#blog"></use></svg>
                        <span>Blog</span>
                     </a>
                  </li>
               </ul>

            </nav>
          </div>
         
        </div>
      </div>

      <div class="layout__bodycol">
        <header class="central-header">
          <div class="central-header__title">
            <h3 class="font-normal">{{mode ? mode : 'Policies'}}</h3>
          </div>
          <div class="central-header__actions">
            <div class="position-relative">
              <div class="dropdown dropdown--central dropdown--persist d-none d-md-flex" id="column-dropdown">
                <a href="#" class="dropdown-toggle dropdown-toggle--central dropdown-toggle--more" data-toggle="dropdown" aria-expanded="true">
                  <svg class="icon">
                    <use xlink:href="#columns"></use>
                  </svg>
                </a>
                <div class="dropdown-menu dropdown-menu-right filter-list__scrollable" x-placement="bottom-end" style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(20px, 20px, 0px);">
                  <div class="filter-list__content">
                    <ul class="filter-list filter-list--central list-unstyled" id="column-filter-list">
                      <li>
                        <label class="custom-input custom-input--checkbox">
                          <input type="checkbox" value="all" name="column-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">Show All</span>
                        </label>
                      </li>
                      <li>
                        <label class="custom-input custom-input--checkbox">
                          <input type="checkbox" checked="checked" value="policy_no" name="column-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">Quote/Policy No.</span>
                        </label>
                      </li>
                      <li>
                        <label class="custom-input custom-input--checkbox">
                          <input type="checkbox" checked="checked" value="brokerage" name="column-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">Brokerage</span>
                        </label>
                      </li>
                      <li>
                        <label class="custom-input custom-input--checkbox">
                          <input type="checkbox" checked="checked" value="broker" name="column-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">Broker</span>
                        </label>
                      </li>
                      <li>
                        <label class="custom-input custom-input--checkbox">
                          <input type="checkbox" checked="checked" value="product" name="column-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">Product</span>
                        </label>
                      </li>
                      <li>
                        <label class="custom-input custom-input--checkbox">
                          <input type="checkbox" checked="checked" value="status" name="column-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">Status</span>
                        </label>
                      </li>
                      <li>
                        <label class="custom-input custom-input--checkbox">
                          <input type="checkbox" checked="checked" value="uw" name="column-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">UW</span>
                        </label>
                      </li>
                      <li>
                        <label class="custom-input custom-input--checkbox">
                          <input type="checkbox" checked="checked" value="inception" name="column-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">Inception Date</span>
                        </label>
                      </li>
                      <li>
                        <label class="custom-input custom-input--checkbox">
                          <input type="checkbox" checked="checked" value="notifications" name="column-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">Notifications</span>
                        </label>
                      </li>
                      <li>
                        <label class="custom-input custom-input--checkbox">
                          <input type="checkbox" checked="checked" value="premium" name="column-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">Premium Total</span>
                        </label>
                      </li>

                    </ul>



                  </div>
                  <div class="filter-list__button">
                    <a href="#" id="columns-apply" class="button button--primary button--block">Apply</a>
                  </div>
                </div>
              </div>

              <div class="guide guide--top-right" id="guide-1-tip-1" style="top:-14px;">
                <div class="guide__close">
                  <svg class="icon">
                    <use xlink:href="#close-circle-small"></use>
                  </svg>
                </div>
                <div class="guide__content">
                  <p>Customize your columns.</p>
                </div>
                <div class="guide__tray">
                  <div class="guide__btn">
                    <a href="#" data-guide-btn="end" class="button button--sm button--everything">Got It</a>
                  </div>
                </div>
              </div>
            </div>
            <a href="#filters" class="central-header__actions-filters is-empty d-none d-md-flex" id="filters-trigger">
              <div>Filters</div>
              <span>0</span>
            </a>
            <a href="javascript:void(0);" [attr.disabled]="!checkAddCover() ? true : null"  (click)="addCover()"
               class="button button--primary button--icon-only d-md-none">
              <svg class="icon">
                <use xlink:href="#plus"></use>
              </svg>
            </a>
            <!-- <a href="#help-modal" data-toggle="modal" class="button button--md button--primary d-none d-md-inline-block">Add Policy</a> -->
            <a href="javascript:void(0);" [attr.disabled]="!checkAddCover() ? true : null" (click)="addCover()"
               class="button button--md button--primary d-none d-md-inline-block">Add Policy</a>
          </div>
        </header>
        <div class="central-filter d-md-none">
          <div class="central-filter__label">
            <p>Sort by: </p>
            <div class="central-filter__filter  ml-0">
              <div class="dropdown dropdown--persist" id="brokerage-dropdown">
                <a href="#modal-traymenu-column-sort" class="dropdown-toggle dropdown-toggle--grey" data-toggle="modal">
                  {{getSortName(request.sort_field)}}
                </a>
              </div>
            </div>
          </div>
          <div class="central-filter__controls">


            <div class="central-filter__filters d-md-none">
              <a href="#modal-traymenu-filters" data-toggle="modal">
                <svg class="icon">
                  <use xlink:href="#filter"></use>
                </svg>
              </a>
            </div>

          </div>
        </div>
        <div *ngIf="false" class="central-filter">
          <div class="central-filter__label">
            <!-- <p class="d-none d-md-block">Brokerage: </p> -->
            <div class="central-filter__filter  ml-0">
              <div class="dropdown dropdown--central dropdown--persist" id="brokerage-dropdown">
                <a href="javascript:void(0);" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                  <!-- {{ selectedInsurer?.short_name.slice(0,30)}}{{selectedInsurer?.short_name.length > 30 ? '...' : ''}} -->
                  Brokerage
                </a>
                <div class="dropdown-menu dropdown-menu-left filter-list__scrollable" x-placement="bottom-start"
                     style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(0px, 14px, 0px);">
                  <div class="filter-list__content">
                    <ul class="filter-list filter-list--central list-unstyled" id="brokerage-filter-list">
                      <li>
                        <label class="custom-input custom-input--checkbox">
                          <input
                            type="checkbox"
                            value="all"
                            [checked]="checkifAllBrokerages()"
                            (change)="onBrokerageFilterChange('all')"
                            id="brokerage-all-checkbox"
                            name="status-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">All</span>
                        </label>
                      </li>
                      <li *ngFor="let insurer of insurers">
                        <label class="custom-input custom-input--checkbox">
                          <input
                            type="checkbox"
                            [checked]="brokerage_ids?.includes(insurer?.insurer_id)"
                            [value]="insurer.insurer_id"
                            (change)="onBrokerageFilterChange(insurer?.insurer_id)"
                            class="brokerage-checkbox"
                            name="brokerage-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">{{insurer.short_name}}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                  <div class="filter-list__button">
                    <button id="brokerage-apply" class="button button--primary button--block" (click)="applyFilters()">Apply</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="central-filter__controls">
            <div *ngIf="mode === 'Underwriting'" class="central-filter__filter d-none d-md-block">
              <div class="dropdown dropdown--central dropdown--persist" id="relevance-dropdown">
                <a href="javascript:void(0);" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                  View[{{uwView}}]
                </a>
                <div class="dropdown-menu dropdown-menu-right filter-list__scrollable" x-placement="bottom-end"
                     style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-158px, 14px, 0px);">
                  <div class="filter-list__content">
                    <div class="filter-list__heading">View mode</div>
                    <ul class="filter-list filter-list--central list-unstyled" id="relevance-filter-list">
                      <li>
                        <label class="custom-input custom-input--radio">
                          <input type="radio" [checked]="uwView === 'Policies'" value="policies" (click)="setView('Policies')"  name="underwriter-mode">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">Policies</span>
                        </label>
                      </li>
                      <li>
                        <label class="custom-input custom-input--radio">
                          <input type="radio" [checked]="uwView === 'Quotes'"  value="quotes" (click)="setView('Quotes')" name="underwriter-mode" >
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">Quotes</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                  <!-- <div class="filter-list__button">
                    <button (click)="changeView()" class="button button--primary button--block">Apply</button>
                  </div> -->
                </div>
              </div>
            </div>
            <div class="central-filter__filter d-none d-md-block">
              <div class="dropdown dropdown--central dropdown--persist" id="status-dropdown">
                <a href="javascript:void(0);" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                  Status
                </a>
                <div class="dropdown-menu dropdown-menu-right filter-list__scrollable" x-placement="bottom-end"
                     style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-158px, 14px, 0px);">
                  <div class="filter-list__content">
                    <div class="filter-list__heading">Status</div>
                    <ul class="filter-list filter-list--central list-unstyled" id="status-filter-list">
                      <li >
                        <label class="custom-input custom-input--checkbox">
                          <input
                            type="checkbox"
                            value="all"
                            [checked]=""
                            (change)="onStatusFilterChange('all')"
                            name="status-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">All</span>
                        </label>
                      </li>
                      <ng-container *ngIf="mode === 'Policies' ">
                      <li *ngFor="let status of statuses">
                        <label class="custom-input custom-input--checkbox">
                          <input
                            type="checkbox"
                            value="status?.policy_status_id"
                            [checked]="status_ids.includes(status?.policy_status_id)"
                            (change)="onStatusFilterChange(status?.policy_status_id)"
                            name="status-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">{{status?.policy_status}}</span>
                        </label>
                      </li>
                    </ng-container>
                    <ng-container *ngIf="mode === 'Quotes'">
                      <li *ngFor="let status of statuses" >
                        <label class="custom-input custom-input--checkbox">
                          <input
                            type="checkbox"
                            value="status?.quote_status_id"
                            [checked]="status_ids.includes(status?.quote_status_id)"
                            (change)="onStatusFilterChange(status?.quote_status_id)"
                            name="status-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">{{status?.quote_status}}</span>
                        </label>
                      </li>
                    </ng-container>
                    <ng-container *ngIf="mode === 'Underwriting' && uwView === 'Policies'">
                      <li *ngFor="let status of statuses" >
                        <label class="custom-input custom-input--checkbox">
                          <input
                            type="checkbox"
                            value="status?.policy_status_id"
                            [checked]="status_ids.includes(status?.policy_status_id)"
                            (change)="onStatusFilterChange(status?.policy_status_id)"
                            name="status-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">{{status?.policy_status}}</span>
                        </label>
                      </li>
                    </ng-container>
                    <ng-container *ngIf="mode === 'Underwriting' && uwView === 'Quotes'">
                      <li *ngFor="let status of statuses" >
                        <label class="custom-input custom-input--checkbox">
                          <input
                            type="checkbox"
                            value="status?.quote_status_id"
                            [checked]="status_ids.includes(status?.quote_status_id)"
                            (change)="onStatusFilterChange(status?.quote_status_id)"
                            name="status-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">{{status?.quote_status}}</span>
                        </label>
                      </li>
                    </ng-container>
                    </ul>
                  </div>
                  <div class="filter-list__button">
                    <button
                      id="status-apply"
                      (click)="applyFilters()"
                      class="button button--primary button--block">
                      Apply
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div *ngIf="mode !== 'Claims' " class="central-filter__filter d-none d-md-block">
              <div class="dropdown dropdown--central dropdown--persist" id="relevance-dropdown">
                <a href="javascript:void(0);" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                  Broker
                </a>
                <div class="dropdown-menu dropdown-menu-right filter-list__scrollable" x-placement="bottom-end"
                     style="position: absolute; will-change: transform; top: 0px; left: 0px; transform: translate3d(-158px, 14px, 0px);">
                  <div class="filter-list__content">
                    <div class="filter-list__heading"></div>
                    <ul class="filter-list filter-list--central list-unstyled" id="broker-filter-list">
                      <li>
                        <label class="custom-input custom-input--checkbox">
                          <input type="checkbox" 
                          [checked]="checkifAllBrokers()" 
                          (click)="onBrokerFilterChange('all')"
                          id="broker-all-checkbox"
                          value="all" name="relevance-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">All</span>
                        </label>
                      </li>
                      <li *ngFor="let broker of brokers">
                        <label class="custom-input custom-input--checkbox">
                          <input type="checkbox" class="broker-checkbox" [value]="broker.person_id" 
                          [checked]="broker_ids?.includes(broker?.person_id)"
                          (click)="onBrokerFilterChange(broker.person_id)"
                          name="relevance-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">{{broker.first_name}} {{broker.last_name}}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                  <div class="filter-list__button">
                    <button id="relevance-apply" (click)="applyFilters()" class="button button--primary button--block">Apply</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="central-filter__filter d-none d-md-block">
              <div class="dropdown dropdown--central dropdown--persist" id="filter-dropdown">
                <a href="javascript:void(0);" class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                  Product </a>
                <div class="dropdown-menu dropdown-menu-right filter-list__scrollable" x-placement="bottom-end"
                     style="position: absolute; transform: translate3d(-148px, 14px, 0px); top: 0px; left: 0px; will-change: transform;">
                  <div class="filter-list__content">
                    <div class="filter-list__heading">Products</div>
                    <ul class="filter-list filter-list--central list-unstyled" id="products-filter-list">
                      <li>
                        <label class="custom-input custom-input--checkbox">
                          <input
                            type="checkbox"
                            (click)="onProductFilterChange('all')"
                            value="all"
                            [checked]="checkIfAllProductsChecked()"
                            name="product-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">All</span>
                        </label>
                      </li>
                      <li *ngFor="let category of categories">
                        <label class="custom-input custom-input--checkbox">
                          <input
                            type="checkbox"
                            (click)="onProductFilterChange(category?.product_category_id)"
                            [checked]="product_ids?.includes(category?.product_category_id)"
                            [value]="category?.product_category_id" name="product-filter[]">
                          <span class="custom-input__indi"></span>
                          <span class="custom-input__label">{{category?.category_name}}</span>
                        </label>
                      </li>
                    </ul>
                  </div>
                  <div class="filter-list__button">
                    <a href="javascript:void(0);" (click)="applyFilters()" id="filter-apply"
                       class="button button--primary button--block">Apply Filters</a>
                  </div>
                </div>
              </div>
            </div>

            <div class="central-filter__filters d-md-none">
              <a href="#modal-traymenu-filters" data-toggle="modal">
                <svg class="icon">
                  <use xlink:href="#filter"></use>
                </svg>
              </a>
            </div>

            <div class="central-filter__trigger is-active" id="table-search-trigger">
              <svg class="icon">
                <use xlink:href="#search-small"></use>
              </svg>
            </div>
            <div class="central-filter__search" id="table-search-container">
              <div class="form-control__wrap has-clear">
                <input
                  type="search"
                  placeholder="Search"
                  autocomplete="none"
                  [(ngModel)]="search_query"
                  (keydown.enter)="searchChange()"
                  class="form-control form-control--sm"/>
                <a href="javascript:void(0);" id="table-search-clear" class="form-control__clear"
                   (click)="clearSearch()">
                  <svg class="icon">
                    <use xlink:href="#close-circle-small"></use>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div class="table__wrap table__wrap--broker table-responsive" id="table-wrap">
          <table datatable [dtOptions]="dtOptions" role="grid" [dtTrigger]="dtTrigger" class="table table--broker table--broker-quotes dataTable no-footer"
                 id="broker-table" style="width: 100% !important;">
            <thead>
            <tr role="row">
              <th data-col="client" class="cell-sticky cell-sticky--left" (click)="setOrder('name')" >
                Client
                <a href="javascript:;" class="table__sorter">
                  <svg class="icon">
                    <use xlink:href="#dropdown-up-smallest"></use>
                  </svg>
                </a>
              </th>
              <th data-col="policy_no" class="sorting" (click)="setOrder(mode === 'Policies' || (uwView === 'Policies' && mode !== 'Quotes')  ?  (mode === 'Claims' ? 'claim_id' : 'policy_id') : 'policy_id')"
                [attr.data-mobile-label]="mode === 'Policies' ? 'Policy No.' : 'Quote No.'">
                {{ mode === 'Policies' || (uwView === 'Policies' && mode !== 'Quotes')  ?  (mode === 'Claims' ? 'Claim No.' : 'Policy No.') : 'Quote No.'}}
                <a  href="javascript:;" class="table__sorter {{ order === 'asc' ? 'is-asc':'is-dsc'}}" data-toggle="sorter">
                  <svg class="icon">
                    <use xlink:href="#dropdown-up-smallest"></use>
                  </svg>
                </a>
              </th>
              <th data-col="brokerage" class="sorting" data-mobile-label="Brokerage">Brokerage </th>
              <th data-col="broker" class="sorting" (click)="setOrder(mode !== 'Claims' ? 'broker' : 'claim')"  [attr.data-mobile-label]="mode !== 'Claims' ? 'Broker' : 'Claim Name'">
                {{ mode !== 'Claims' ? 'Broker' : 'Claim Name'}}
                <a href="javascript:;" class="table__sorter {{ order === 'asc' ? 'is-asc':'is-dsc'}}" data-toggle="sorter">
                  <svg class="icon">
                    <use xlink:href="#dropdown-up-smallest"></use>
                  </svg>
                </a>
              </th>
              <th data-col="product" class="sorting" (click)="setOrder('category_name')" data-mobile-label="Product">
                Product
                <a  href="javascript:;" class="table__sorter {{ order === 'asc' ? 'is-asc':'is-dsc'}}" data-toggle="sorter">
                  <svg class="icon">
                    <use xlink:href="#dropdown-up-smallest"></use>
                  </svg>
                </a>
              </th>
              <th data-col="status" class="sorting" (click)="setOrder('policy_status')"  data-mobile-label="Status">
                Status
                <a  href="javascript:;" class="table__sorter {{ order === 'asc' ? 'is-asc':'is-dsc'}}" data-toggle="sorter">
                  <svg class="icon">
                    <use xlink:href="#dropdown-up-smallest"></use>
                  </svg>
                </a>
              </th>
             
              <th data-col="uw" [style]="mode === 'Claims' ? 'display: none' : null"  class="sorting" (click)="setOrder('uw_score')"  data-mobile-label="UW" tabindex="0" aria-controls="broker-table" rowspan="1"
                  colspan="1" aria-label="UW: activate to sort column ascending">
                UW
                <a  href="javascript:;" class="table__sorter {{ order === 'asc' ? 'is-asc':'is-dsc'}}" data-toggle="sorter">
                  <svg class="icon">
                    <use xlink:href="#dropdown-up-smallest"></use>
                  </svg>
                </a>
              </th>
              <th data-col="inception" [attr.data-mobile-label]="mode === 'Claims' ? 'Claim Date' : mode === 'Quotes' ? 'Quote Date' : 'Inception Date' " (click)="setOrder('date_inception')" >
               {{ mode === 'Claims' ? 'Claim Date' : mode == 'Quotes' ? 'Quote Date' : uwView !== 'Policies' ? 'Quote Date' : 'Inception Date' }}
               <a  href="javascript:;" class="table__sorter {{ order === 'asc' ? 'is-asc':'is-dsc'}}" data-toggle="sorter">
                <svg class="icon">
                  <use xlink:href="#dropdown-up-smallest"></use>
                </svg>
              </a>
              </th>
              <th data-col="notifications">Notifications</th>
              <th data-col="premium" [style]="mode === 'Claims' ? 'display: none' : null"  class="cell-premium text-right" (click)="setOrder('prem_value')" data-mobile-label="Premium Total ">
                Premium Total
                <a  href="javascript:;" class="table__sorter {{ order === 'asc' ? 'is-asc':'is-dsc'}}" data-toggle="sorter">
                  <svg class="icon">
                    <use xlink:href="#dropdown-up-smallest"></use>
                  </svg>
                </a>
              </th>
              <th data-col="actions" class="cell-sticky cell-sticky--right cell-sticky--actions">&nbsp;</th>
              <th data-col="actions-menu" class="cell-sticky">&nbsp;</th>
            </tr>
            </thead>
            <tbody id="table-content">
              <tr *ngIf="isEmpty">
                <td colspan="12">
                  <div class="table-noresults__content">
                    <img src="assets/0/img/home/unsure.svg" alt="" class="img-fluid">
                    <h3 class="font-normal">No results found</h3>
                    <p>Try adjusting your search to find what you’re looking for.</p>
                  </div>
                </td>
              </tr>
            <tr *ngFor="let policy of policies;" >
              <td data-col="client" *ngIf="policy?.category_id !== 1" (click)="goTo(policy, $event)" class="cell-sticky cell-sticky--left"><strong>{{policy.person[0]?.first_name}} {{policy.person[0]?.last_name}}</strong></td>
              <td data-col="client" *ngIf="policy?.category_id === 1" (click)="goTo(policy, $event)" class="cell-sticky cell-sticky--left"><strong>{{policy?.company_name}}</strong></td>
              <td data-col="policy_no" (click)="goTo(policy, $event)">{{policy.policy_id}}/{{policy?.version_id}}</td>
              <td data-col="brokerage" data-id="brokerage">...</td>
              <td data-col="broker" *ngIf="mode === 'Claims' " (click)="goTo(policy, $event)">{{policy?.claim_name}}</td>
              <td data-col="broker" *ngIf="mode !== 'Claims' " data-id="broker">{{policy?.broker_user}}</td>
              <td data-col="product" (click)="goTo(policy, $event)">
                <img src="assets/{{policy.product_category_id}}/favicon/favicon.svg" class="icon icon--sm mr-10"
                     alt=""/>
                <strong>{{policy.category_name}}</strong>
              </td>
              <td data-col="status">
                <span
                  class="tag-pill"
                  [ngClass]="{
                  'tag-pill--active': policy.policy_status === 'Active' || policy.policy_status === 'Claim Registered' || policy.policy_status === 'Converted',
                  'tag-pill--paused': policy.policy_status === 'Paused' || policy.policy_status === 'In Progress' || policy.policy_status === 'Rejected',
                  'tag-pill--inactive': policy.policy_status === 'Cancelled' || policy.policy_status === 'Expired' || policy.policy_status === 'Suspended' || policy.policy_status === 'Removed' || policy.policy_status === 'Revoked'
                  }">
                  {{policy?.policy_status}}
                </span>
              </td>
              <td data-col="uw" [style]="mode === 'Claims' ? 'display: none' : null" >
                <span (click)=" this.mode = 'Underwriting'; goTo(policy, $event) "
                  *ngIf="policy.uw_score > 0"
                  class="tag-pill"
                  [ngClass]="{
                  'tag-pill--status-amber': policy.uw_score === 1 || policy.uw_score === 2,
                  'tag-pill--status-red': policy.uw_score === 3,
                  'tag-pill--status-green': policy.uw_score > 3
                  }">
                  {{policy.uw_score}}
                </span>
              </td>
              <td data-col="inception">{{policy.date_inception | date: 'yyyy-MM-dd'}}</td>
              <td data-col="notifications">
                <span (click)="this.mode = 'Notifications'; goTo(policy, $event)" [routerLink]="['/' + RouterLinks.NotificationsLanding]" class="tag-pill tag-pill--status-green">0</span>
              </td>
              <td data-col="premium" [style]="mode === 'Claims' ? 'display: none' : null"  class="text-right"><strong>{{policy?.currency}} {{accounting.formatNumber(policy.prem_value)}}</strong>/{{policy?.frequency_short}}</td>
              <td data-col="actions" class="has-action text-right cell-sticky cell-sticky--right cell-sticky--actions">
                <!-- <a
                  *ngIf="!person?.underwriter"
                  href="#modal-notes-notify"
                  data-toggle="modal"
                  class="icon-hover icon-hover--slim icon-hover--alt">
                  <svg class="icon">
                    <use xlink:href="#notifications-small"></use>
                  </svg>
                </a>
                <a
                  href="javascript:void(0);"
                  class="icon-hover icon-hover--slim icon-hover--alt" data-tooltip="tooltip" data-placement="top" title=""
                  data-original-title="4 Conditions">
                  <svg class="icon">
                    <use xlink:href="#warning-small"></use>
                  </svg>
                </a> -->
              </td>
              <td data-col="actions-menu" class="has-action cell-min cell-sticky">
                <div  class="dropdown">
                  <a href="javascript:void(0);" (click)="setPolicy(policy)"
                     class="dropdown-toggle dropdown-toggle--central dropdown-toggle--nocaret d-none d-md-block"
                     data-toggle="dropdown">
                    <svg class="icon">
                      <use xlink:href="#more"></use>
                    </svg>
                  </a>
                  <a href="#modal-traymenu-actions" (click)="setPolicy(policy)"
                     class="dropdown-toggle dropdown-toggle--central dropdown-toggle--nocaret d-md-none"
                     data-toggle="modal">
                    <svg class="icon">
                      <use xlink:href="#more"></use>
                    </svg>
                  </a>
                  <div *ngIf="person?.underwriter" class="dropdown-menu dropdown-menu-right dropdown-menu--central">
                    <a (click)="goTo(policy, $event)" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#info"></use>
                      </svg>
                      <span>View Policy</span>
                    </a>
                    <a class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#info"></use>
                      </svg>
                      <span>Notify Client</span>
                    </a>
                    <a (click)="editPolicy(policy,'cancel')" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#trash-bin"></use>
                      </svg>
                      <span>Cancel Policy</span>
                    </a>
                    <a *ngIf="mode === 'Quotes' && policy.policy_status === 'Active'"
                       href="javascript:;" (click)="openAssignBroker(policy)"
                       data-toggle="modal" data-target="#modal-assign-broker"
                       class="dropdown-item" data-sortby="best_value">
                      <svg class="icon"><use xlink:href="#profile"></use></svg>
                      <span>Assign Broker</span>
                    </a>

                  </div>
                  <div *ngIf="!person?.underwriter" class="dropdown-menu dropdown-menu-right dropdown-menu--central">
                    <a *ngIf="mode !== 'Claims' && policy.policy_status === 'Active'" href="javascript:void(0);" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#info"></use>
                      </svg>
                      <span>Contact Client</span>
                    </a>
                    <a *ngIf="mode !== 'Claims' && policy.policy_status === 'Active' " class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#info"></use>
                      </svg>
                      <span>Contact Underwriter</span>
                    </a>
                    <a *ngIf="mode === 'Quotes'" (click)="downloadQuoteSchedule(policy)" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#download"></use>
                      </svg>
                      <span>Download Quote Schedule</span>
                    </a>
                    <a *ngIf="mode === 'Quotes' && policy?.policy_status === 'Expired'" (click)="reactivateQuote(policy)" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#play"></use>
                      </svg>
                      <span>Reactivate Quote</span>
                    </a>
                    <a [routerLink]="['/' + RouterLinks.NotificationsLanding]" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#notifications"></use>
                      </svg>
                      <span>Notifications</span>
                    </a>
                    <a  href="#blacklist-modal" *ngIf="person?.console_access" (click)="setPolicy(policy)" class="dropdown-item" data-toggle="modal" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#lock"></use>
                      </svg>
                      <span>Add to blacklist</span>
                    </a>
                    <a  (click)="editProfile(policy)" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#profile"></use>
                      </svg>
                      <span>Edit Profile</span>
                    </a>
                     <a *ngIf="policy?.policy_version_rel_type_id !== 2 " (click)="editProfile(policy,false)" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#profile"></use>
                      </svg>
                      <span>Edit Policyholder</span>
                    </a>
                    <a *ngIf="mode === 'Quotes'" (click)="viewTranscript(policy)" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#download"></use>
                      </svg>
                      <span>View Transcript</span>
                    </a>
                    <a *ngIf="mode === 'Quotes' && policy.policy_status === 'Active'" (click)="resendQuoteLink(policy)" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#info"></use>
                      </svg>
                      <span>Resend Quote Link</span>
                    </a>
                    <a *ngIf="person?.console_access && mode === 'Quotes' && policy.policy_status === 'Active'"
                       href="javascript:;" (click)="openAssignBroker(policy)"
                       data-toggle="modal" data-target="#modal-assign-broker"
                       class="dropdown-item" data-sortby="best_value">
                      <svg class="icon"><use xlink:href="#profile"></use></svg>
                      <span>Assign Broker</span>
                    </a>
                    <a *ngIf="mode === 'Policies'" href="javascript:;" (click)="startClaim(policy)" class="dropdown-item">
                      <svg class="icon"><use xlink:href="#add-items"></use></svg>
                      <span>Add Claim</span>
                    </a>
                    <a *ngIf="mode === 'Claims'" href="javascript:;" (click)="goTo(policy, $event)" class="dropdown-item">
                      <svg class="icon"><use xlink:href="#edit"></use></svg>
                      <span>Edit Claim</span>
                    </a>
                    <a *ngIf="mode === 'Claims'" href="javascript:;" (click)="removeClaim(policy?.policy_id)" class="dropdown-item">
                      <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
                      <span>Remove Claim</span>
                    </a>
                     <a (click)=" this.mode = 'evi'; goTo(policy, $event)" class="dropdown-item" data-sortby="best_value">
                      <svg class="icon">
                        <use xlink:href="#play-circle"></use>
                      </svg>
                      <span>Evi Post Signup</span>
                    </a>
                    <!-- <a *ngIf="mode === 'Policies' && policy.policy_status === 'Active'" href="javascript:;" (click)="editPolicy(policy,'pause')" class="dropdown-item">
                      <svg class="icon"><use xlink:href="#pause"></use></svg>
                      <span>Pause</span>
                    </a> -->
                    <a *ngIf="mode === 'Policies' && policy.policy_status === 'Active'" href="javascript:;" (click)="editPolicy(policy,'cancel')" class="dropdown-item">
                      <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
                      <span>Cancel</span>
                    </a>
                    <a *ngIf="mode === 'Policies' && policy.policy_status === 'Paused'" href="javascript:;" (click)="editPolicy(policy, 'resume')" class="dropdown-item">
                      <svg class="icon"><use xlink:href="#reinstate-small"></use></svg>
                      <span>Resume</span>
                    </a>
                    <a *ngIf="mode === 'Policies' && policy.policy_status === 'Cancelled'" href="javascript:;" (click)="editPolicy(policy,'restore')" class="dropdown-item">
                      <svg class="icon"><use xlink:href="#play-circle"></use></svg>
                      <span>Restore</span>
                    </a>

                    
                  </div>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

</main>

<!-- Pause Policy Modal -->
<app-pause-policy
#pausePolicyComponent
[frequency_id]="frequency_id"
[policy]="selectedPolicy"
(getNewData)="onPolicyActionChange($event)">
</app-pause-policy>

<!-- Cancel Policy Modal -->
<app-cancel-policy
#cancelPolicyComponent
[frequency_id]="frequency_id"
[policy]="selectedPolicy"
(pauseModal)="openPauseCoverFromCancel($event)"
(getNewData)="onPolicyActionChange($event)">
</app-cancel-policy>

<app-resume-policy
#resumePolicyComponent
[policy]="selectedPolicy"
[frequency_id]="frequency_id"
(getNewData)="onPolicyActionChange($event)">
</app-resume-policy>

<app-restore-policy
#restorePolicyComponent
[frequency_id]="frequency_id"
[policy]="selectedPolicy"
(getNewData)="onPolicyActionChange($event)">
</app-restore-policy>

<app-emergency-services-modal [active]="true" #emergencyServicesModalComponent></app-emergency-services-modal>

<app-disclaimer></app-disclaimer>
<div class="modal fade fade-up modal--fullscreen" id="app-bar-more" tabindex="-1" role="dialog" aria-labelledby="app-bar-more" aria-modal="true" >
  <div class="modal-dialog" role="document">
     <div class="modal-content modal-appbar">
           <nav class="modal-appbar__menu">
           
               <div class="modal-appbar__menu-title"><small>Cover</small></div>
               <ul>
                  <li>
                     <a href="javascritp:;">
                        <svg class="icon"><use xlink:href="#memberships"></use></svg>
                        <span>Underwriting</span>
                     </a>
                  </li>
               </ul>
           
               <!-- <div class="modal-appbar__menu-title"><small>Policies</small></div>
               <ul>
                  <li>
                     <a href="#">
                        <svg class="icon"><use xlink:href="#document"></use></svg>
                        <span>Documents</span>
                     </a>
                  </li>
                  <li>
                     <a href="#">
                        <svg class="icon"><use xlink:href="#inventory"></use></svg>
                        <span>Insured items</span>
                     </a>
                  </li>
                  <li>
                     <a href="#">
                        <svg class="icon"><use xlink:href="#policy-benefits"></use></svg>
                        <span>Benefits</span>
                     </a>
                  </li>
               </ul> -->
           
               <!-- <div class="modal-appbar__menu-title"><small>Support</small></div>
               <ul>
                  <li>
                     <a href="#">
                        <svg class="icon"><use xlink:href="#mobile-call"></use></svg>
                        <span>Give us a call</span>
                     </a>
                  </li>
                  <li>
                     <a href="#">
                        <svg class="icon"><use xlink:href="#request-call"></use></svg>
                        <span>Request a call</span>
                     </a>
                  </li>
                  <li>
                     <a href="#">
                        <svg class="icon"><use xlink:href="#chat"></use></svg>
                        <span>Chat to us</span>
                     </a>
                  </li>
               </ul> -->

               <div class="modal-appbar__menu-title"><small>General</small></div>
               <ul>
                  <li [class]="mode === 'Notifications' ? 'is-active' : ''">
                     <a href="javascript:;" data-dismiss="modal" (click)="changeMode('Notifications')">
                        <svg class="icon"><use xlink:href="#notifications"></use></svg>
                        <span>Notifications</span>
                     </a>
                  </li>
               </ul>

               <div class="modal-appbar__menu-title"><small>Resources</small></div>
               <ul>
                  <li>
                     <a href="#">
                        <svg class="icon"><use xlink:href="#video-screen"></use></svg>
                        <span>Tips and how-tos</span>
                     </a>
                  </li>
                  <li>
                     <a href="#">
                        <svg class="icon"><use xlink:href="#q-a"></use></svg>
                        <span>FAQs</span>
                     </a>
                  </li>
                  <li>
                     <a href="#">
                        <svg class="icon"><use xlink:href="#blog"></use></svg>
                        <span>Blog</span>
                     </a>
                  </li>
               </ul>

            </nav>
           <!-- <div class="modal-appbar__sos">
              <div class="modal-appbar__sos-inner">
                 <a href="javascript:;" (click)="startSOSFlow()" class="button button--block button--lg button--primary">
                    <svg class="icon">
                       <use xlink:href="#navigation-sos"></use>
                    </svg>
                    Emergency Assistance
                 </a>
              </div>
           </div> -->
     </div>         
  </div>  
</div>
<div class="modal fade modal--alert" id="view-modal" tabindex="-1" role="dialog"
     aria-labelledby="pause-summary-modal" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/0/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h4>Which view would you like to use?</h4>
          </div>
        </div>
      </div>
      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:void(0);" routerLink="/everything.policy-overview" id="pause-summary-no"
             class="button button--lg button--primary" data-dismiss="modal">Broker</a>

          <a href="javascript:void(0);" routerLink="/everything.underwriter-landing" id="pause-summary-no"
             class="button button--lg button--secondary" data-dismiss="modal">Underwriter</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal--note" id="modal-notes-notify" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content modal-note">
      <div class="modal-note__heading">
        <div class="container">
          <h5>Notes</h5>
          <button class="modal-note__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-note__content">
        <div class="container">
          <div class="notetree">
            <div class="notetree__item">
              <div class="notetree__item-branch">
                <svg class="icon">
                  <use xlink:href="#note-filled"></use>
                </svg>
              </div>
              <div class="notetree__item-content">
                <div class="notetree__item-title">
                  <h5>Lia Bhardvaj</h5>
                  <time>July 23, 2020</time>
                </div>
                <div class="rte">
                  <p>[Message from UW to Broker: Vestibulum pellentesque ex tortor, pellentesque lacinia elit efficitur
                    in. Ut dignissim ac justo at aliquam. Donec et commodo nulla. Proin quis ex ac ligula laoreet.]</p>
                </div>
                <div class="tag-pill__list mt-10">
                  <a href="javascript:void(0);" class="tag-pill tag-pill--file">
                    <svg class="icon">
                      <use xlink:href="#attachment"></use>
                    </svg>
                    [filename].pdf</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- mobile menu modal -->
<div class="modal fade modal--fullscreen" id="mobile-quote-menu" tabindex="-1" role="dialog"
     aria-labelledby="mobile-quote-menu" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-everything">
      <div class="modal-everything__header">
        <div class="container">
          <div class="modal-everything__title">
            Our Products
          </div>
          <button type="button" data-dismiss="modal" aria-label="Close" class="modal-everything__close">
            <svg class="icon">
              <use xlink:href="#close-circle-small"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-everything__content">
        <div class="container">
          <ul class="everything-categories-mobile list-unstyled">
            <li>
              <a href="javascript:void(0);" class="everything-categories-mobile__item">
                <svg-icon src="assets/1/logo.svg" alt="Business.Insure" class="img-fluid fill-business" [applyClass]="true"></svg-icon>
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" class="everything-categories-mobile__item">
                <svg-icon src="assets/4/logo.svg" alt="Life.Insure" class="img-fluid fill-lifestyle" [applyClass]="true"></svg-icon>
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" class="everything-categories-mobile__item">
                <svg-icon src="assets/3/logo.svg" alt="Personal.Insure" class="img-fluid fill-personal" [applyClass]="true"></svg-icon>
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" class="everything-categories-mobile__item">
                <svg-icon src="assets/2/logo.svg" alt="Professional.Insure" class="img-fluid fill-professional" [applyClass]="true"></svg-icon>
              </a>
            </li>
            <li>
              <a href="javascript:void(0);" class="everything-categories-mobile__item">
                <svg-icon src="assets/5/logo.svg" alt="Tourism.Insure" class="img-fluid fill-tourism"></svg-icon>
              </a>
            </li>
            <li>
              <div class="everything-categories-mobile__item everything-categories-mobile__item--unsure">
                <p><strong>Unsure?</strong></p>
                <p><a href="javascript:void(0);"><strong>Let us help you</strong></a></p>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="modal-everything__actions">
        <div class="container">
          <button class="button button--block button--secondary">Login</button>
          <button class="button button--block button--primary-gradient">Get a Quote</button>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /modal -->
<!-- help modal -->
<div class="modal fade modal--max" id="help-modal" tabindex="-1" role="dialog" aria-labelledby="help-modal"
     aria-hidden="true">
  <div class="modal-dialog modal-help" role="document">
    <div class="modal-content modal-help__inner">
      <header class="modal-help__header">
        <a href="javascript:void(0);" class="modal-help__back">
          <svg class="icon">
            <use xlink:href="#arrow-left-small"></use>
          </svg>
          <span>Back</span>
        </a>
        <a href="javascript:void(0);" class="modal-help__close" data-dismiss="modal">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </a>
      </header>
      <div class="modal-help__content">
        <div class="container">

          <div class="modal-help__title">
            <h2 class="font-serif">What do you want to insure?</h2>
          </div>


          <div class="modal-help__categories is-active">
            <p>Our products extend to every facet of life, from personal home and car, to business assets, professional
              indemnity, to death and disability cover as well as travel insurance. Whatever your insurance needs, we’ve
              got you covered.</p>

            <!-- add everything-categories--extended for max 4 products per row -->
            <ul class="everything-categories list-unstyled">
              <li>
                <a href="javascript:void(0);" class="everything-categories__item">
                  <svg-icon src="assets/1/logo.svg" alt="Business.Insure" class="img-fluid fill-business" [applyClass]="true"></svg-icon>
                  <div class="everything-categories__item-content">
                    <p>Everything you own in a business from assets to liability cover.</p>
                  </div>
                  <div class="everything-categories__item-btn text-color-business">
                    <span>Get a Quote</span>
                    <svg class="icon">
                      <use xlink:href="#arrow-right"></use>
                    </svg>
                  </div>
                  <div class="everything-categories__item-indi bg-color-business"></div>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" class="everything-categories__item">
                  <svg-icon src="assets/4/logo.svg" alt="Life.Insure" class="img-fluid fill-lifestyle" [applyClass]="true"></svg-icon>
                  <div class="everything-categories__item-content">
                    <p>Everything to do with your general life and risks you face. </p>
                  </div>
                  <div class="everything-categories__item-btn text-color-life">
                    <span>Get a Quote</span>
                    <svg class="icon">
                      <use xlink:href="#arrow-right"></use>
                    </svg>
                  </div>
                  <div class="everything-categories__item-indi bg-color-life"></div>
                </a>
              </li>
              <li>
                <a href="#product-personal" data-product="true" class="everything-categories__item">
                  <svg-icon src="assets/3/logo.svg" alt="Personal.Insure" class="img-fluid fill-personal" [applyClass]="true"></svg-icon>
                  <div class="everything-categories__item-content">
                    <p>Everything you care about and own in your personal capacity.</p>
                  </div>
                  <div class="everything-categories__item-btn text-color-personal">
                    <span>Get Started</span>
                    <svg class="icon">
                      <use xlink:href="#arrow-right"></use>
                    </svg>
                  </div>
                  <div class="everything-categories__item-indi bg-color-personal"></div>
                </a>
              </li>
              <li>
                <a href="#product-professional" data-product="true" class="everything-categories__item">
                  <svg-icon src="assets/2/logo.svg" alt="Professional.Insure" class="img-fluid fill-professional" [applyClass]="true"></svg-icon>
                  <div class="everything-categories__item-content">
                    <p>Everything to insure you as a professional in the event that you get sued.</p>
                  </div>
                  <div class="everything-categories__item-btn text-color-professional">
                    <span>Get Started</span>
                    <svg class="icon">
                      <use xlink:href="#arrow-right"></use>
                    </svg>
                  </div>
                  <div class="everything-categories__item-indi bg-color-professional"></div>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" class="everything-categories__item">
                  <svg-icon src="assets/5/logo.svg" alt="Tourism.Insure" class="img-fluid fill-tourism" [applyClass]="true"></svg-icon>
                  <div class="everything-categories__item-content">
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
                  </div>
                  <div class="everything-categories__item-btn text-color-professional">
                    <span>Get a Quote</span>
                    <svg class="icon">
                      <use xlink:href="#arrow-right"></use>
                    </svg>
                  </div>
                  <div class="everything-categories__item-indi bg-color-professional"></div>
                </a>
              </li>
              <li>
                <a href="javascript:void(0);" class="everything-categories__item everything-categories__item--unsure">
                  <img src="assets/0/img/home/unsure.svg" alt="" class="img-fluid">
                  <p><strong>Unsure what insurance you need?</strong></p>
                  <p><span class="link"><strong>Let us help you</strong></span></p>
                </a>
              </li>
            </ul>

          </div>

          <div class="modal-help__products">
            <ul class="everything-products everything-products--personal list-unstyled" id="product-personal">
              <li>
                <div class="everything-products__copy">
                  <h4>Comprehensive Professional Liability</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--personal-gradient">Get a Quote</a>
              </li>
              <li>
                <div class="everything-products__copy">
                  <h4>Medical Malpractice</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--personal-gradient">Get a Quote</a>
              </li>
              <li>
                <div class="everything-products__copy">
                  <h4>Tradesman</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--personal-gradient">Get a Quote</a>
              </li>
            </ul>
            <ul class="everything-products everything-products--professional list-unstyled" id="product-professional">
              <li>
                <div class="everything-products__copy">
                  <h4>Comprehensive Professional Liability</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--professional-gradient">Get a Quote</a>
              </li>
              <li>
                <div class="everything-products__copy">
                  <h4>Medical Malpractice</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--professional-gradient">Get a Quote</a>
              </li>
              <li>
                <div class="everything-products__copy">
                  <h4>Tradesman</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--professional-gradient">Get a Quote</a>
              </li>
              <li>
                <div class="everything-products__copy">
                  <h4>SME Professional Liability</h4>
                  <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc pellen tesque vitae justo non
                    sodales. Phasellus in justo ut risus congue volutpat.</p>
                </div>
                <a href="javascript:void(0);" class="button button--professional-gradient">Get a Quote</a>
              </li>
            </ul>
          </div>

        </div>
      </div>


    </div>
  </div>
</div>
<!-- /modal -->
<!-- tray menu modal (mobile only) -->
<div class="modal fade modal--tray" id="modal-traymenu-actions" tabindex="-1" role="dialog"
     aria-labelledby="modal-traymenu-more" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu">
      <div class="container">
        <div class="modal-traymenu__list list-unstyled">
          <a href="javascript:void(0);" data-dismiss="modal"  class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#info"></use>
            </svg>
            <div>Contact Client</div>
          </a>
          <a href="#modal-contact-uw" data-dismiss="modal"  data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#info"></use>
            </svg>
            <div>Contact Underwriter</div>
          </a>
          <a *ngIf="mode === 'Quotes'" data-dismiss="modal" (click)="downloadQuoteSchedule(selectedPolicy)"  data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#download"></use>
            </svg>
            <div>Download Quote Schedule</div>
          </a>
          <a *ngIf="mode === 'Quotes' && selectedPolicy?.policy_status === 'Expired'" (click)="reactivateQuote(selectedPolicy)" data-dismiss="modal"  data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#play"></use>
            </svg>
            <div>Reactivate Quote</div>
          </a>
          <a href="javascript:;" data-dismiss="modal" [routerLink]="['/' + RouterLinks.NotificationsLanding]" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#notifications"></use>
            </svg>
            <div>Notifications</div>
          </a>
          <a href="#blacklist-modal" data-dismiss="modal"  *ngIf="person?.console_access" (click)="setPolicy(selectedPolicy)" data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#lock"></use>
            </svg>
            <div>Add to Blacklist</div>
          </a>
          <a href="javascript:;" data-dismiss="modal"  (click)="complianceVault(selectedPolicy)" data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#lock"></use>
            </svg>
            <div>Edit Profile</div>
          </a>
          <a href="javascript:;" data-dismiss="modal"  (click)="complianceVault(selectedPolicy)" data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon">
              <use xlink:href="#lock"></use>
            </svg>
            <div>Edit Policyholder</div>
          </a>
          <a *ngIf="(person?.console_access || person?.underwriter) && mode === 'Quotes' && selectedPolicy?.policy_status === 'Active'"
             href="#modal-assign-broker" data-dismiss="modal" data-toggle="modal"
             class="modal-traymenu__list-item">
            <svg class="icon"><use xlink:href="#profile"></use></svg>
            <div>Assign Broker</div>
          </a>
          <a *ngIf="mode === 'Policies'" data-dismiss="modal"  href="javascript:;" (click)="startClaim(selectedPolicy)" data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon"><use xlink:href="#add-items"></use></svg>
            <div>Add Claim</div>
          </a>
          <a *ngIf="mode === 'Claims'" data-dismiss="modal"  href="javascript:;" (click)="goTo(selectedPolicy, $event)" data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon"><use xlink:href="#edit"></use></svg>
            <span>Edit Claim</span>
          </a>
          <a *ngIf="mode === 'Claims'" data-dismiss="modal"  href="javascript:;" (click)="removeClaim(selectedPolicy?.policy_id)" data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
            <span>Remove Claim</span>
          </a>
          <!-- <a *ngIf="mode === 'Policies' && selectedPolicy?.policy_status === 'Active'" data-dismiss="modal"  href="javascript:;" (click)="editPolicy(selectedPolicy,'pause')" data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon"><use xlink:href="#pause"></use></svg>
            <span>Pause</span>
          </a> -->
          <a *ngIf="mode === 'Policies' && selectedPolicy?.policy_status === 'Active'" data-dismiss="modal"  href="javascript:;" (click)="editPolicy(selectedPolicy,'cancel')" data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon"><use xlink:href="#trash-bin"></use></svg>
            <span>Cancel</span>
          </a>
          <a *ngIf="mode === 'Policies' && selectedPolicy?.policy_status === 'Paused'" data-dismiss="modal" href="javascript:;" (click)="editPolicy(selectedPolicy, 'resume')" data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon"><use xlink:href="#reinstate-small"></use></svg>
            <span>Resume</span>
          </a>
          <a *ngIf="mode === 'Policies' && selectedPolicy?.policy_status === 'Cancelled'" data-dismiss="modal" href="javascript:;" (click)="editPolicy(selectedPolicy,'restore')" data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon"><use xlink:href="#play-circle"></use></svg>
            <span>Restore</span>
          </a>
          <a data-dismiss="modal" href="javascript:;" (click)=" this.mode = 'evi'; goTo(selectedPolicy, $event)" data-toggle="modal" class="modal-traymenu__list-item">
            <svg class="icon"><use xlink:href="#play-circle"></use></svg>
            <span>Evi Post Signup</span>
          </a>
        </div>

        <a href="javascript:void(0);" data-dismiss="modal" class="modal-traymenu__close">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
          <div>Close</div>
        </a>
      </div>
    </div>
  </div>
</div>
<!-- /modal -->

<!-- tray menu modal (mobile only) -->
<div class="modal fade modal--tray" id="modal-traymenu-filters" tabindex="-1" role="dialog"
     aria-labelledby="modal-traymenu-filters" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu modal-traymenu--fs">

      <div class="modal-traymenu__header">
        <div class="container">
          <h6>Filters ({{policies?.length}})</h6>
          <a href="javascript:void(0);" class="modal-traymenu__header-clear" id="clear-mobile-filters">Clear</a>
          <a href="javascript:void(0);" data-dismiss="modal" class="modal-traymenu__header-close">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </a>
        </div>
      </div>

      <div class="modal-traymenu__filters">
        <div class="container">

          <div class="filter-list__heading">Products</div>
          <ul class="filter-list filter-list--central list-unstyled" id="mobile-products-filter-list">
            <li>
              <label class="custom-input custom-input--checkbox">
                <input type="checkbox" (click)="onProductFilterChange('all')" value="all" [checked]="checkIfAllProductsChecked()"
                  name="product-filter[]">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">All</span>
              </label>
            </li>
            <li *ngFor="let category of categories">
              <label class="custom-input custom-input--checkbox">
                <input
                  type="checkbox"
                  (click)="onProductFilterChange(category?.product_category_id)"
                  [checked]="product_ids?.includes(category?.product_category_id)"
                  [value]="category?.product_category_id" name="product-filter[]">
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">{{category.category_name }}</span>
              </label>
            </li>
           
          </ul>

          <div class="filter-list__heading">Status</div>
          <ul class="filter-list filter-list--central list-unstyled" id="mobile-status-filter-list">
            <li>
              <label class="custom-input custom-input--checkbox">
                <input type="checkbox" 
                [checked]="" 
                (change)="onStatusFilterChange('all')"
                name="mobile-status-filter[]"/>
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">All</span>
              </label>
            </li>
            <ng-container *ngIf="mode === 'Policies' ">
            <li *ngFor="let status of statuses">
              <label class="custom-input custom-input--checkbox">
                <input type="checkbox" 
                value="status?.policy_status_id"
                [checked]="status_ids.includes(status?.policy_status_id)"
                (change)="onStatusFilterChange(status?.policy_status_id)"
                name="mobile-status-filter[]"/>
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">{{status?.policy_status}}</span>
              </label>
            </li>
          </ng-container>
          <ng-container *ngIf="mode !== 'Policies' ">
            <li *ngFor="let status of statuses">
              <label class="custom-input custom-input--checkbox">
                <input type="checkbox" 
                value="status?.quote_status_id"
                [checked]="status_ids.includes(status?.quote_status_id)"
                (change)="onStatusFilterChange(status?.quote_status_id)"
                name="mobile-status-filter[]"/>
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">{{status?.quote_status}}</span>
              </label>
            </li>
          </ng-container>
       
          </ul>

          <div class="filter-list__heading">Premium Order</div>
          <ul class="filter-list filter-list--central list-unstyled" id="mobile-relevance-filter-list">
            <li>
              <label class="custom-input custom-input--radio">
                <input type="radio" checked="" value="high-low" name="mobile-premium-filter[]"/>
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">Premium High to Low</span>
              </label>
            </li>
            <li>
              <label class="custom-input custom-input--radio">
                <input type="radio" value="low-high" name="mobile-premium-filter[]"/>
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">Premium Low to High</span>
              </label>
            </li>
          </ul>

          <!-- <div class="filter-list__heading">Relevance</div>
          <ul class="filter-list filter-list--central list-unstyled" id="mobile-relevance-filter-list">
            <li>
              <label class="custom-input custom-input--radio">
                <input type="radio" checked="" value="me" name="mobile-relevance-filter[]"/>
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">Relevant to me</span>
              </label>
            </li>
            <li>
              <label class="custom-input custom-input--radio">
                <input type="radio" value="all" name="mobile-relevance-filter[]"/>
                <span class="custom-input__indi"></span>
                <span class="custom-input__label">All users</span>
              </label>
            </li>
          </ul> -->
        </div>
      </div>

      <div class="modal-traymenu__btn">
        <div class="container">
          <a href="javascript:void(0);" data-dismiss="modal" class="button button--primary button--block"
             id="mobile-filter-apply" (click)="applyFilters()">Apply</a>
        </div>
      </div>
    </div>
  </div>
</div>
<!-- /modal -->
<!-- /modal -->

<div class="modal fade modal--alert" id="select-broker" tabindex="-1" data-backdrop="static" data-keyboard="false"
     role="dialog" aria-labelledby="offline" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/0/avatar/happy.png"
                 class="img-fluid" alt=""/>
          </div>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h4>Please select brokerage</h4>
            <select name="selectBroker" id="selectBroker" class="ui-selectmenu">
              <option value="">Select Option</option>
              <option *ngFor="let broker of brokers" [value]="broker.brokerid">{{broker.brokername}}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:void(0);" id="pause-summary-no" (click)="getPolicies()"
             class="button button--lg button--primary" data-dismiss="modal">Done</a>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="modal fade modal--alert" id="inactive-modal" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="error-modal"
     aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--prorata">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img [src]="'assets/0/avatar/sad.png'" alt=""
                 class="img-fluid">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-circle-small"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h4>Oops!</h4>
            <p class="error-text"></p>
          </div>
        </div>
      </div>
      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:;" class="button button--lg button--primary" data-dismiss="modal">OK</a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal modal--max modal--widest fade" id="advanced-search-modal" tabindex="-1" role="dialog" aria-labelledby="advanced-search-modal"  aria-modal="true">
  <div class="modal-dialog" role="document">
    <form class="modal-content modal-filter" id="advanced-search-form">

      <div class="modal-filter__title">
        Advanced search
        <a href="#" class="modal-filter__close" data-dismiss="modal">
          <svg class="icon">
            <use xlink:href="#close-medium"></use>
          </svg>
        </a>
      </div>

      <div class="modal-filter__content">
        <div class="modal-filter__content-inner">

            <div class="advanced-search-group">
              <div class="advanced-search-group__label advanced-search-group__label--center">Keyword</div>
              <div class="advanced-search-group__fields">
                <input type="text" class="form-control" id="advanced-search-keyword">
              </div>
            </div>

            <div class="advanced-search-group">
              <div class="advanced-search-group__label">Status</div>
              <div class="advanced-search-group__fields">

                <div class="advanced-search-group__status" id="advanced-search-status-group">

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-active" value="active">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Active</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-approved" value="approved">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Approved</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-progress" value="in%20progress">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">In Progress</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-notification" value="received%20notification">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Received Notification</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-renewal" value="renewal%20due">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Renewal Due</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-declined" value="request%20declined">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Request Declined</span>
                  </label>

                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" name="search-status-underwriting" value="underwriting">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Underwriting</span>
                  </label>

                </div>


              </div>
            </div>

            <div class="advanced-search-group">
              <div class="advanced-search-group__label advanced-search-group__label--center">Date Range</div>
              <div class="advanced-search-group__fields">

                <div class="form-group mb-0">
                  <div class="form-group__daterange">
                    <app-question-date-picker 
                    [question]="[]" 
                    [showLabel]="false" 
                    [numberMonths]="1"
                    [showIcon]="true"
                    [maxDate]="0"
                      (questionAnswer)="setStartDate($event)">
                    </app-question-date-picker>
                    <div class="form-group__daterange-to">
                      to
                    </div>
                    <app-question-date-picker 
                    [question]="[]" 
                    [showLabel]="false" 
                    [numberMonths]="1"
                    [showIcon]="true"
                    [maxDate]="0"
                      (questionAnswer)="setEndDate($event)">
                    </app-question-date-picker>
                  </div>
                </div>
               


              </div>
            </div>

        



        </div>
      </div>

      <div class="modal-filter__btn">
        <a href="#" disabled="disabled" class="button button--naked button--no-min" id="advanced-search-clear">Reset</a>
        <a href="javascript:;" (click)="globalSearch()" class="button button--primary" id="advanced-search-submit">Search</a>
      </div>

    </form>
  </div>
</div>
<div id="filters" class="filters">
  <div class="filters__inner">
    <div class="filters__header">
      <h5>Filters</h5>
      <a href="#" class="filters__header-close" data-close="filter">
        <svg class="icon">
          <use xlink:href="#close-medium"></use>
        </svg>
      </a>
    </div>
    <div class="filters__body">

      <div class="filter-accordion">
        <div class="filter-accordion__item">
          <div class="filter-accordion__header">
            <label class="custom-input custom-input--checkbox">
              <input type="checkbox" checked="checked">
              <span class="custom-input__indi"></span>
            </label>
            <a href="#filter-item-1" class="filter-accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
              <div class="filter-accordion__title-text">Status</div>
              <span class="filter-accordion__title-indi">
                <svg class="icon">
                  <use xlink:href="#minus"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#plus"></use>
                </svg>
              </span>
            </a>
          </div>
          <div id="filter-item-1" class="filter-accordion__body collapse" style="">
            <div class="filter-accordion__content">

              <div class="filter-accordion__search">
                <div class="form-group">
                  <div class="input-group">
                    <input type="text" value="" placeholder="Search by status" class="form-control" data-input="search-filter">
                    <div class="input-group-append">
                      <span class="input-group-icon">
                        <svg class="icon">
                          <use xlink:href="#search"></use>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>


              <ul class="filter-accordion__list">
                <li>
                  <label class="custom-input custom-input--checkbox">
                  <input type="checkbox" value="all" [checked]="" (change)="onStatusFilterChange('all')" name="status-filter[]">
                  <span class="custom-input__indi"></span>
                  <span class="custom-input__label">All</span>
                </label>
                </li>
                <ng-container *ngIf="mode === 'Policies' ">
                  <li *ngFor="let status of statuses">
                    <label class="custom-input custom-input--checkbox">
                      <input type="checkbox" value="status?.policy_status_id"
                        [checked]="status_ids.includes(status?.policy_status_id)"
                        (change)="onStatusFilterChange(status?.policy_status_id)" name="status-filter[]">
                      <span class="custom-input__indi"></span>
                      <span class="custom-input__label">{{status?.policy_status}}</span>
                    </label>
                  </li>
                </ng-container>
                <ng-container *ngIf="mode === 'Quotes'">
                  <li *ngFor="let status of statuses">
                    <label class="custom-input custom-input--checkbox">
                      <input type="checkbox" value="status?.quote_status_id" [checked]="status_ids.includes(status?.quote_status_id)"
                        (change)="onStatusFilterChange(status?.quote_status_id)" name="status-filter[]">
                      <span class="custom-input__indi"></span>
                      <span class="custom-input__label">{{status?.quote_status}}</span>
                    </label>
                  </li>
                </ng-container>
                <ng-container *ngIf="mode === 'Underwriting' && uwView === 'Policies'">
                  <li *ngFor="let status of statuses">
                    <label class="custom-input custom-input--checkbox">
                      <input type="checkbox" value="status?.policy_status_id"
                        [checked]="status_ids.includes(status?.policy_status_id)"
                        (change)="onStatusFilterChange(status?.policy_status_id)" name="status-filter[]">
                      <span class="custom-input__indi"></span>
                      <span class="custom-input__label">{{status?.policy_status}}</span>
                    </label>
                  </li>
                </ng-container>
                <ng-container *ngIf="mode === 'Underwriting' && uwView === 'Quotes'">
                  <li *ngFor="let status of statuses">
                    <label class="custom-input custom-input--checkbox">
                      <input type="checkbox" value="status?.quote_status_id" [checked]="status_ids.includes(status?.quote_status_id)"
                        (change)="onStatusFilterChange(status?.quote_status_id)" name="status-filter[]">
                      <span class="custom-input__indi"></span>
                      <span class="custom-input__label">{{status?.quote_status}}</span>
                    </label>
                  </li>
                </ng-container>
              </ul>
            </div>
          </div>
        </div>

        <div class="filter-accordion__item">
          <div class="filter-accordion__header">
            <label class="custom-input custom-input--checkbox">
              <input type="checkbox">
              <span class="custom-input__indi"></span>
            </label>
            <a href="#filter-item-2" class="filter-accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
              <div class="filter-accordion__title-text">Brokerage</div>
              <span class="filter-accordion__title-indi">
                <svg class="icon">
                  <use xlink:href="#minus"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#plus"></use>
                </svg>
              </span>
            </a>
          </div>
          <div id="filter-item-2" class="filter-accordion__body collapse">
            <div class="filter-accordion__content">

              <div class="filter-accordion__search">
                <div class="form-group">
                  <div class="input-group">
                    <input type="text" value="" placeholder="Search by brokerage" class="form-control" data-input="search-filter">
                    <div class="input-group-append">
                      <span class="input-group-icon">
                        <svg class="icon">
                          <use xlink:href="#search"></use>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <ul class="filter-accordion__list">
                <li>
                  <label class="custom-input custom-input--checkbox">
                    <input
                      type="checkbox"
                      value="all"
                      [checked]="checkifAllBrokerages()"
                      (change)="onBrokerageFilterChange('all')"
                      id="brokerage-all-checkbox"
                      name="status-filter[]">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">All</span>
                  </label>
                </li>
                <li *ngFor="let insurer of insurers">
                  <label class="custom-input custom-input--checkbox">
                    <input
                      type="checkbox"
                      [checked]="brokerage_ids?.includes(insurer?.insurer_id)"
                      [value]="insurer.insurer_id"
                      (change)="onBrokerageFilterChange(insurer?.insurer_id)"
                      class="brokerage-checkbox"
                      name="brokerage-filter[]">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">
                      <div class="custom-input__label-tag">
                        <span class="tag-pill tag-pill--brokerage tag-pill--brokerage-1">{{insurer?.short_name?.substring(0,2) | uppercase }}</span>
                      </div>
                      {{insurer.short_name}}</span>
                  </label>
                </li>
              
              </ul>
            </div>
          </div>
        </div>
        <div class="filter-accordion__item">
          <div class="filter-accordion__header">
            <label class="custom-input custom-input--checkbox">
              <input type="checkbox">
              <span class="custom-input__indi"></span>
            </label>
            <a href="#filter-item-3" class="filter-accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
              <div class="filter-accordion__title-text">Broker</div>
              <span class="filter-accordion__title-indi">
                <svg class="icon">
                  <use xlink:href="#minus"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#plus"></use>
                </svg>
              </span>
            </a>
          </div>
          <div id="filter-item-3" class="filter-accordion__body collapse">
            <div class="filter-accordion__content">

              <div class="filter-accordion__search">
                <div class="form-group">
                  <div class="input-group">
                    <input type="text" value="" placeholder="Search by broker" class="form-control" data-input="search-filter">
                    <div class="input-group-append">
                      <span class="input-group-icon">
                        <svg class="icon">
                          <use xlink:href="#search"></use>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <ul class="filter-accordion__list">
                <li>
                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" 
                    [checked]="checkifAllBrokers()" 
                    (click)="onBrokerFilterChange('all')"
                    id="broker-all-checkbox"
                    value="all" name="relevance-filter[]">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">All</span>
                  </label>
                </li>
                <li *ngFor="let broker of brokers">
                  <label class="custom-input custom-input--checkbox">
                    <input type="checkbox" class="broker-checkbox" [value]="broker.person_id" 
                    [checked]="broker_ids?.includes(broker?.person_id)"
                    (click)="onBrokerFilterChange(broker.person_id)"
                    name="relevance-filter[]">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">{{broker.first_name}} {{broker.last_name}}</span>
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="filter-accordion__item">
          <div class="filter-accordion__header">
            <label class="custom-input custom-input--checkbox">
              <input type="checkbox">
              <span class="custom-input__indi"></span>
            </label>
            <a href="#filter-item-4" class="filter-accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
              <div class="filter-accordion__title-text">Product</div>
              <span class="filter-accordion__title-indi">
                <svg class="icon">
                  <use xlink:href="#minus"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#plus"></use>
                </svg>
              </span>
            </a>
          </div>
          <div id="filter-item-4" class="filter-accordion__body collapse">
            <div class="filter-accordion__content">

              <div class="filter-accordion__search">
                <div class="form-group">
                  <div class="input-group">
                    <input type="text" value="" placeholder="Search by product" class="form-control" data-input="search-filter">
                    <div class="input-group-append">
                      <span class="input-group-icon">
                        <svg class="icon">
                          <use xlink:href="#search"></use>
                        </svg>
                      </span>
                    </div>
                  </div>
                </div>
              </div>

              <ul class="filter-accordion__list">
                <li>
                  <label class="custom-input custom-input--checkbox">
                    <input
                      type="checkbox"
                      (click)="onProductFilterChange('all')"
                      value="all"
                      [checked]="checkIfAllProductsChecked()"
                      name="product-filter[]">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">All</span>
                  </label>
                </li>
                <li *ngFor="let category of categories">
                  <label class="custom-input custom-input--checkbox">
                    <input
                      type="checkbox"
                      (click)="onProductFilterChange(category?.product_category_id)"
                      [checked]="product_ids?.includes(category?.product_category_id)"
                      [value]="category?.product_category_id" name="product-filter[]">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">{{category?.category_name}}</span>
                  </label>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div *ngIf="mode === 'Underwriting'"  class="filter-accordion__item">
          <div class="filter-accordion__header">
            <a href="#filter-item-view" class="filter-accordion__title collapsed" data-toggle="collapse" aria-expanded="false">
              <div class="filter-accordion__title-text">View Mode</div>
              <span class="filter-accordion__title-indi">
                <svg class="icon">
                  <use xlink:href="#minus"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#plus"></use>
                </svg>
              </span>
            </a>
          </div>
          <div id="filter-item-view" class="filter-accordion__body collapse">
            <div class="filter-accordion__content">

              <ul class="filter-accordion__list">
                <li>
                  <label class="custom-input custom-input--radio">
                    <input type="radio" name="radio-filter" (click)="setView('Policies')" [checked]="uwView === 'Policies'">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Policies</span>
                  </label>
                </li>
                <li>
                  <label class="custom-input custom-input--radio">
                    <input type="radio" name="radio-filter" (click)="setView('Quotes')" [checked]="uwView !== 'Policies'">
                    <span class="custom-input__indi"></span>
                    <span class="custom-input__label">Quotes</span>
                  </label>
                </li>
               
              </ul>
            </div>
          </div>
        </div>


      </div>


    </div>
    <div class="filters__tray">
      <a href="javascript:;" id="filters-reset-btn" (click)="resetFilters()" class="button button--block button--secondary">Reset</a>
      <a href="javascript:;" id="filters-apply-btn" (click)="applyFilters()" class="button button--block button--primary">Apply</a>
    </div>
  </div>
</div>

<app-assign-broker-modal
  [selectedRecord]="selectedPolicy"
  [mode]="mode"
  [brokerages]="insurers"
  (saved)="rerender()">
</app-assign-broker-modal>
<div class="modal fade modal--tray " id="modal-traymenu-column-sort" tabindex="-1" role="dialog" aria-labelledby="modal-traymenu-column-sort" aria-modal="true" >
  <div class="modal-dialog">
    <div class="modal-content modal-traymenu modal-traymenu--fs">

      <div class="modal-traymenu__header">
        <div class="container">
          <h6>Sort by</h6>
          <a href="#" class="modal-traymenu__header-clear" id="clear-mobile-sort">Reset</a>
          <a href="#" data-dismiss="modal" class="modal-traymenu__header-close">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </a>
        </div>
      </div>

      <div class="modal-traymenu__filters">
        <div class="container">

          <ul class="sort-list list-unstyled" id="mobile-column-sort-list">
            <li data-col-id="{{col?.id}}" *ngFor="let col of SortColumns" [ngClass]="{'is-active': col.id === request?.sort_field}">
              <div class="sort-list__status">
                <svg class="icon">
                  <use xlink:href="#success-small"></use>
                </svg>
              </div>
              <div class="sort-list__label" (click)="setOrder(col.id)">{{col.name}}</div>
              <div class="sort-list__direction sorting_desc" [ngClass]="{'sorting_asc': sort === 'asc', 'sorting_desc': sort === 'desc'}">
                <svg class="icon" (click)="setSort('asc')"> 
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
                <svg class="icon" (click)="setSort('desc')">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
              </div>
            </li>

            
            <!-- <li data-col-id="2">
              <div class="sort-list__status">
                <svg class="icon">
                  <use xlink:href="#success-small"></use>
                </svg>
              </div>
              <div class="sort-list__label">Brokerge</div>
              <div class="sort-list__direction">
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
              </div>
            </li>
            <li data-col-id="3">
              <div class="sort-list__status">
                <svg class="icon">
                  <use xlink:href="#success-small"></use>
                </svg>
              </div>
              <div class="sort-list__label">Broker</div>
              <div class="sort-list__direction">
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
              </div>
            </li>
            <li data-col-id="1">
              <div class="sort-list__status">
                <svg class="icon">
                  <use xlink:href="#success-small"></use>
                </svg>
              </div>
              <div class="sort-list__label">Quote No.</div>
              <div class="sort-list__direction">
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
              </div>
            </li>
            <li data-col-id="4">
              <div class="sort-list__status">
                <svg class="icon">
                  <use xlink:href="#success-small"></use>
                </svg>
              </div>
              <div class="sort-list__label">Product</div>
              <div class="sort-list__direction">
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
              </div>
            </li>
            <li data-col-id="5">
              <div class="sort-list__status">
                <svg class="icon">
                  <use xlink:href="#success-small"></use>
                </svg>
              </div>
              <div class="sort-list__label">Status</div>
              <div class="sort-list__direction">
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
              </div>
            </li>
            <li data-col-id="6">
              <div class="sort-list__status">
                <svg class="icon">
                  <use xlink:href="#success-small"></use>
                </svg>
              </div>
              <div class="sort-list__label">UW</div>
              <div class="sort-list__direction">
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
              </div>
            </li>
            <li data-col-id="7">
              <div class="sort-list__status">
                <svg class="icon">
                  <use xlink:href="#success-small"></use>
                </svg>
              </div>
              <div class="sort-list__label">Inception Date</div>
              <div class="sort-list__direction">
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
              </div>
            </li>
            <li data-col-id="8">
              <div class="sort-list__status">
                <svg class="icon">
                  <use xlink:href="#success-small"></use>
                </svg>
              </div>
              <div class="sort-list__label">Notifications</div>
              <div class="sort-list__direction">
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
              </div>
            </li>
            <li data-col-id="9">
              <div class="sort-list__status">
                <svg class="icon">
                  <use xlink:href="#success-small"></use>
                </svg>
              </div>
              <div class="sort-list__label">Premium</div>
              <div class="sort-list__direction">
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
                <svg class="icon">
                  <use xlink:href="#arrow-left-small"></use>
                </svg>
              </div>
            </li> -->
          </ul>

        </div>
      </div>

      <div class="modal-traymenu__btn">
        <div class="container">
          <a href="#" (click)="applyFilters()" data-dismiss="modal" class="button button--primary button--block" id="mobile-column-sort-apply">Apply</a>
        </div>
      </div>


    </div>
  </div>
</div>
<div class="modal fade modal--alert" id="cancel-policy-uw-date-modal" tabindex="-1" role="dialog"
     aria-labelledby="cancel-date-modal"
     aria-modal="true" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">
      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img [src]="'assets/' + selectedPolicy?.product_category_id + '/avatar/happy.png'" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close"data-dismiss="modal" >
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>
      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h4>When would you like to cancel
              {{selectedPolicy?.product_name}} cover?</h4>
          </div>
          <div class="form-group mt-30 mb-0">

            <div class="mt-15">
              <app-question-date-picker
                [dateFormat]="'dd/MM/yyyy'"
                [numberMonths]="1"
                [minDate]="selectedPolicy?.date_inception"
                [showIcon]="true"
                [category]="selectedPolicy?.category_id"
                (questionAnswer)="setUwDate($event)">
              </app-question-date-picker>
            </div>
            <div class="mt-15">
              <app-question-dropdown *ngIf="options?.length >0"
                [readOnly]="false"
                [labelText]="'Reason Option'"
                [question]="null"
                [showLabel]="true"
                [options]="options"
                (questionAnswer)="getReasonID($event)">
              </app-question-dropdown>
            </div>
            
              <div class="mt-15">
                <div class="form-group form-group--lg">
                  <textarea
                  placeholder="Reason for cancellation"
                  [(ngModel)]="responsetext"
                  (blur)="getReasonText()"
                  name="txtReason"
                  rows="5"
                  class="form-control">
                </textarea>
                </div>
                <!-- <app-question-textarea
                [question]="{question_prompt:'Reason for cancellation', email_version:'Reason for cancellation'}"
                [readonly]="false"
                (questionAnswer)="getReasonText($event)">
              </app-question-textarea> -->
              </div>
              
          </div>
        </div>
      </div>
      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:void(0)" class="button button--lg button--secondary" data-dismiss="modal">I'd Rather
            Not</a>
          <a href="javascript:void(0)"
             class="button button--lg button--primary"
             [attr.disabled]="(uwDate === '') || !reasonProvided ? true : null"
             (click)="uwCancellationRequest()">Cancel Cover</a>
        </div>
      </div>
      
    </div>
  </div>
</div>
<div class="modal fade modal--alert" id="blacklist-modal" tabindex="-1" data-backdrop="static" data-keyboard="false"
     role="dialog" aria-labelledby="offline" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/0/avatar/happy.png"
                 class="img-fluid" alt=""/>
          </div>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h4>Please state reason</h4>
           <textarea [(ngModel)]="blacklistReason" name="txtReason" rows="5" class="form-control"></textarea>
          </div>
        </div>
      </div>

      <div class="modal-alert__button">
        <div class="container">
          <a href="javascript:void(0);" id="pause-summary-no" [attr.disabled]="blacklistReason.length > 3 ? null : true" (click)="addPersonToBlacklist()"
             class="button button--lg button--primary" data-dismiss="modal">Add</a>
        </div>
      </div>
    </div>
  </div>
</div>
